import { featureItems } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            <i className="ri-shield-check-line"></i>
            为什么选择我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-foreground-500 text-sm mt-2">
            五大优势，打造极致韩漫阅读体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5 md:gap-6">
          {featureItems.map((item, idx) => (
            <div
              key={item.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200/50 transition-all cursor-default"
            >
              <div className={`w-14 h-14 md:w-16 md:h-16 rounded-xl flex items-center justify-center mx-auto mb-4 ${
                idx === 0 ? 'bg-primary-100' :
                idx === 1 ? 'bg-accent-100' :
                idx === 2 ? 'bg-secondary-100' :
                idx === 3 ? 'bg-primary-100' :
                'bg-accent-100'
              }`}>
                <i className={`${item.icon} text-2xl ${
                  idx === 0 ? 'text-primary-500' :
                  idx === 1 ? 'text-accent-500' :
                  idx === 2 ? 'text-secondary-500' :
                  idx === 3 ? 'text-primary-500' :
                  'text-accent-500'
                }`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 font-heading">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}